const reservationRoutes = {
  path: 'reservations',
  name: 'reservationsOverview',
  components: {
    default: () => import('@/views/PageRoutView')
  },
  redirect: { name: 'reservations' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '/:channelId/reservations',
      name: 'reservations',
      component: () => import('@/views/Reservations/Reservations'),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/:channelId/reservations/:reservationId',
      name: 'reservations-detail',
      component: () => import('@/views/Reservations/ReservationDetail'),
      meta: {
        requiresAuth: true
      }
    },
  ]
}

export default reservationRoutes
